function scrollElementIntoView({ containerId, elementId, padding = 0, behavior = 'smooth', }) {
    const scrollContainer = document.getElementById(containerId);
    const el = document.getElementById(elementId);
    if (!scrollContainer || !el)
        return;
    const containerRect = scrollContainer.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    const offset = elRect.top - containerRect.top - padding;
    scrollContainer.scrollBy({
        top: offset,
        behavior,
    });
}
export default scrollElementIntoView;
